/**
 * Story 1.9 — Versao da aplicacao injetada em build time pelo Vite.
 *
 * Antes era constante hardcoded ("2026.05.05.00.00") que precisava ser
 * atualizada manualmente — o que permitia que builds diferentes
 * mostrassem a MESMA versao, mascarando bugs de cache stale no
 * browser do usuario.
 *
 * Agora vem de:
 *   1. CI/CD env (`VITE_APP_VERSION` ou `GITHUB_SHA[0:8]`)
 *   2. git SHA local (dev)
 *   3. Fallback "dev" se nada disponivel
 *
 * Setup em `vite.config.ts` (define: `__APP_VERSION__`).
 *
 * Usado por:
 *   - `useVersionCheck` hook (compara com `/api/version` do servidor)
 *   - Sidebar (exibe no rodape)
 *   - Logger (auditoria)
 */
declare const __APP_VERSION__: string;
declare const __BUILD_TIME__: string;

// Fallback para o caso de o build nao injetar (deveria sempre injetar).
export const APP_VERSION: string =
  typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

export const APP_BUILD_TIME: string =
  typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : 'unknown';
